export default {"src":"/_next/static/media/amazon-color.75cbc651.svg","height":30,"width":94,"blurWidth":0,"blurHeight":0};